module.exports = __webpack_public_path__ + "img/25.ac2f5e48.jpg";